import Vue from 'vue';
import router from '@/router';
import { VueAuthenticate } from 'vue-authenticate';
import { API_URLS_BOARD } from '@/constants';

import Pusher from 'pusher-js'; // import Pusher
import Echo from 'laravel-echo';

import axios from 'axios';
import VueAxios from 'vue-axios';
import * as Sentry from "@sentry/vue";
Vue.use(VueAxios, axios);

// Token con el que se creó la conexión actual de window.Echo — permite
// detectar un re-login sin recargar la página (token nuevo) y recrear la
// conexión en vez de quedar pegada para siempre al token viejo (ver initEcho).
let lastEchoToken = null;

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    tokenName: 'access_token',
    loginUrl: 'api/auth/login',
    registerUrl: 'api/auth/registro',
    logoutUrl: 'api/auth/logout'
});


export default {
    state: {
        // AUTH
        isAuthenticated: false,
        isAuthenticatedFacturacion: false,
        errors: [],
        twoFAError: false,
        google2fa_enable: true
    },

    getters: {
        //AUTH
        isAuthenticated(state) {
            return state.isAuthenticated;
        },

        authToken(state) {
            return vueAuth;
        },

        isAuthenticatedFacturacion(state) {
            return state.isAuthenticatedFacturacion;
        },

        errors(state) {
            return state.errors;
        },
        twoFAError(state) {
            return state.twoFAError;
        },
        google2fa_enable(state) {
            return state.google2fa_enable;
        }

    },

    mutations: {

        // AUTH
        isAuthenticated(state, payload) {
            state.isAuthenticated = payload.isAuthenticated;
        },

        clerarAuthenticated(state) {
            state.isAuthenticated = false;
        },

        isAuthenticatedFacturacion(state, payload) {
            state.isAuthenticatedFacturacion = payload.isAuthenticatedFacturacion;
        },

        errors(state, payload) {
            state.errors = payload.errors;
        },

        logout(state, payload) {
            state.isAuthenticated = false;
            state.twoFAError = false;
            state.errors = [];
            // LIMPIAR USUARIO EN SENTRY 
            Sentry.setUser(null);
        },

        // USER
        updateUser(state, user) {
            // Merge en vez de reemplazo: preserva campos existentes (permisos,
            // roles, id...) que no vienen en el payload editado (ej: perfil).
            state.isAuthenticated.user = { ...state.isAuthenticated.user, ...user };
        },
        twoFAError(state, payload) {
            state.twoFAError = payload;
        },
        google2fa_enable(state, payload) {
            state.google2fa_enable = payload;
        }
    },

    actions: {
        login(context, payload) {
            return vueAuth.login(payload.user, payload.requestOptions)
                .then((response) => {
                    if (response.data.user.estado == 1) {

                        //  CONFIGURAR SENTRY PARA ESTE USUARIO ===
                        Sentry.setUser({
                            id: response.data.user.id || '-',
                            username: response.data.user.username || '-'
                        });
                        context.commit('errors', {
                            errors: []
                        });
                        context.commit('isAuthenticated', {
                            isAuthenticated: response.data
                        });
                        //recibimos una indicacion del backend que nos dice si el user requiere verificacion 2fa o no;
                        const twoFaRequired = process.env.VUE_APP_DISABLE_2FA === 'true' ? false : response.data.twoFaVerify;
                        context.commit('twoFAError', twoFaRequired);
                        context.commit('google2fa_enable', response.data.twoFaVerify);
                        if (twoFaRequired) {
                            context.commit('twoFAError', true);
                            router.push('/view2fa')
                        } else {
                            // Sesión completa: conectar WebSockets y suscribir badges.
                            context.dispatch('initEcho');
                            context.dispatch('counters/subscribeCounters', null, { root: true });
                            context.dispatch('counters/loadCounters', true, { root: true });
                            context.dispatch('ticketsRealtime/subscribeTicketsRealtime', null, { root: true });
                            context.dispatch('ordenesTrabajoRealtime/subscribeOTRealtime', null, { root: true });
                            router.push({ path: '/' });
                        }
                    } else {
                        context.commit('errors', {
                            errors: 'Usuario Deshabilitado'
                        });
                    }

                })
                .catch((error) => {
                    console.log(error);
                    context.commit('errors', {
                        errors: error.response.data.errors
                    });
                });
        },

        async auth2fa(context, secret = '') {
            let url = process.env.VUE_APP_API_BASE_URL + '/api/auth/verifyCode';
            try {
                let response = await axios.post(url, { secret: secret });
                // console.log("response: ", response );
                if (response.data.success) {
                    context.commit('twoFAError', false);
                    // Sesión completa tras 2FA: conectar WebSockets y suscribir badges.
                    context.dispatch('initEcho');
                    context.dispatch('counters/subscribeCounters', null, { root: true });
                    context.dispatch('counters/loadCounters', true, { root: true });
                    context.dispatch('ticketsRealtime/subscribeTicketsRealtime', null, { root: true });
                    router.push({ path: '/' });
                }
                else if (response.response.data.twoFaError && response.response.data.twoFaError == true) throw new Error(response);


            } catch (error) {
                if (error.response && error.response.status && error.response.status == 401) {
                    console.log("catch: status ", error.response.status);
                    context.commit('twoFAError', false);
                    context.commit('logout');
                    router.push('/auth/signin');
                }
                console.log("catch: ", error);
            }

        },

        loginFacturacion(context) {
            let url = process.env.VUE_APP_API_FACTURACION_BASE_URL + '/oauth/token';
            let params = {
                grant_type: 'password',
                client_id: process.env.VUE_APP_API_FACTURACION_CLIENT_ID_OAUTH,
                client_secret: process.env.VUE_APP_API_FACTURACION_CLIENT_SECRET_OAUTH,
                username: process.env.VUE_APP_API_FACTURACION_USER_OAUTH,
                password: process.env.VUE_APP_API_FACTURACION_USER_PASS_OAUTH
            };

            axios.post(url, params)
                .then((response) => {
                    context.commit('isAuthenticatedFacturacion', {
                        isAuthenticatedFacturacion: response.data
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        register(context, payload) {
            return vueAuth.register(payload.user, payload.requestOptions)
                .then((response) => {
                    context.commit('isAuthenticated', {
                        isAuthenticated: response
                    });
                    router.push({ path: '/auth/signin' });
                })
                .catch((error) => {
                    context.commit('errors', {
                        errors: error.response.data.errors
                    });
                });
        },

        logout(context, payload) {
            context.commit('clientContext/CLEAR_CLIENT', null, { root: true });
            // Cerrar WebSockets y dejar de escuchar contadores.
            context.dispatch('counters/unsubscribeCounters', null, { root: true });
            context.dispatch('ticketsRealtime/unsubscribeTicketsRealtime', null, { root: true });
            context.dispatch('ordenesTrabajoRealtime/unsubscribeOTRealtime', null, { root: true });
            context.dispatch('teardownEcho');
            /* let url = vueAuth.options.baseUrl + "/" + vueAuth.options.logoutUrl;
            // const params = {
            //     params: {
            //         user: context.state.isAuthenticated
            //     }
            // }
            //url = http://api/api/auth/logout

            return axios.get(url)
                .then((response) => {
                    router.push('/auth/signin');
                    setTimeout(() => {
                        context.commit("logout");
                    }, 1000);
                })
                .catch((error) => {
                    //
                }); */
        },

        auth(context) {
            if (context.state.isAuthenticated == false) {
                router.push('/auth/signin');
                return false;
            } else {
                if (!context.state.isAuthenticated.access_token) {
                    router.push('/auth/signin');
                } else {
                    // La conexión de WebSockets se inicializa vía la acción initEcho
                    // (llamada en login/2fa y al arrancar la app en App.vue).
                    context.dispatch('initEcho');
                }
            }
        },

        /**
         * Inicializa el cliente de WebSockets (laravel-echo + pusher-js apuntando
         * al servidor de Laravel WebSockets) y lo expone en window.Echo para que
         * el resto de la app pueda suscribirse a canales.
         *
         * Es seguro llamarla varias veces: si ya existe window.Echo con el
         * mismo token no hace nada; si el token cambió (re-login sin recargar
         * la página, típico tras expirar el anterior — Passport vence a las
         * 12hs, ver AuthServiceProvider::personalAccessTokensExpireIn), se
         * recrea la conexión desde cero en vez de quedar pegada para siempre
         * al token viejo.
         */
        initEcho(context) {
            if (typeof window === 'undefined') return;

            const auth = context.state.isAuthenticated;
            const token = auth && auth.access_token;
            if (!token) return; // sin sesión, no conectamos

            // Sin key configurada no inicializamos (los badges usan el fallback por polling).
            if (!process.env.VUE_APP_WEBSOCKET_KEY) return;

            if (window.Echo && lastEchoToken === token) return; // ya inicializado con este token

            if (window.Echo) {
                // Token distinto al de la conexión actual: recrear desde cero.
                context.dispatch('ticketsRealtime/unsubscribeTicketsRealtime', null, { root: true });
                context.dispatch('ordenesTrabajoRealtime/unsubscribeOTRealtime', null, { root: true });
                context.dispatch('teardownEcho');
            }

            try {
                // laravel-echo (broadcaster pusher) necesita Pusher en el scope global.
                window.Pusher = Pusher;

                const authEndpoint = process.env.VUE_APP_API_BASE_URL + '/api/broadcasting/auth';

                const config = {
                    broadcaster: 'pusher',
                    key: process.env.VUE_APP_WEBSOCKET_KEY,
                    cluster: process.env.VUE_APP_WEBSOCKET_CLUSTER || 'mt1', // requerido por pusher-js v7
                    forceTLS: String(process.env.VUE_APP_WEBSOCKET_TLS ?? 'true') === 'true',
                    enabledTransports: ['ws', 'wss'],
                    disableStats: true,
                    // authorizer en vez de auth.headers estático: pusher-js llama a esto
                    // en CADA intento de autorización de canal privado, no solo al crear
                    // la conexión — incluida cada reconexión automática tras un corte de
                    // red. Con auth.headers estático, esas reconexiones reautorizaban con
                    // el token capturado al momento de crear window.Echo, aunque el store
                    // ya tuviera uno más nuevo. Leer context.state acá en cada llamada
                    // evita quedar pegado a ese token viejo mientras la conexión siga viva.
                    authorizer: (channel) => ({
                        authorize: (socketId, callback) => {
                            axios.post(
                                authEndpoint,
                                { socket_id: socketId, channel_name: channel.name },
                                {
                                    headers: {
                                        Authorization: 'Bearer ' + context.state.isAuthenticated?.access_token,
                                        'X-Requested-With': 'XMLHttpRequest',
                                    },
                                }
                            )
                                .then((response) => callback(false, response.data))
                                .catch((error) => callback(true, error));
                        },
                    }),
                };

                // Self-hosted (Laravel WebSockets / Soketi propio): apunta al host propio.
                // Si NO se define VUE_APP_WEBSOCKET_SERVER, se usa un broker hospedado
                // (Pusher / Soketi Cloud) y pusher-js resuelve el host desde el cluster
                // (recomendado en hosting cPanel/CloudLinux).
                if (process.env.VUE_APP_WEBSOCKET_SERVER) {
                    const port = Number(process.env.VUE_APP_WEBSOCKET_PORT) || 6001;
                    config.wsHost = process.env.VUE_APP_WEBSOCKET_SERVER;
                    config.wsPort = port;
                    config.wssPort = port;
                }

                window.Echo = new Echo(config);
                lastEchoToken = token;
            } catch (error) {
                console.warn('No se pudo inicializar Echo (WebSockets):', error);
            }
        },

        /** Cierra la conexión de WebSockets (al cerrar sesión). */
        teardownEcho() {
            lastEchoToken = null;
            if (typeof window === 'undefined' || !window.Echo) return;
            try {
                window.Echo.disconnect();
            } catch (e) {
                // noop
            }
            window.Echo = null;
        },

        updateUser(context, user) {
            context.commit('updateUser', user);
            let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.updateUser; //ANCHOR[id=ALL-DATA]

            const params = {
                nombre: user.nombre,
                email: user.email,
                color: user.color
            };

            return axios.post(url, params)
                .then((response) => {
                    //
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }
}
